import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { getVersion } from "../../../Utils/CommonService";
import { useSelector } from "react-redux";
import dateFormat from "dateformat";

const Footer = () => {
  const version = useSelector((state) => state.common.version);
  const versionDate = useSelector((state) => state.common.versionDate);

  useEffect(() => {
    getVersion();
  }, [version, versionDate]);

  const formattedVersionDate = versionDate
    ? dateFormat(new Date(versionDate), "dd-mm-yyyy HH:MM:ss")
    : "N/A";

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row className="justify-content-end align-items-center text-center w-100">
            {/* Left side */}
            <Col sm="auto" className="text-end">
              <div className="d-none d-sm-block">
                {`Version: ${version}`}
              </div>
            </Col>

            {/* Center separator */}
            <Col sm="auto">
              <div className="text-sm-center d-none d-sm-block">|</div>
            </Col>

            {/* Right side aligned to flex-end */}
            <Col sm="auto" className="text-end">
              <div className="d-none d-sm-block">
                {`Version Date: ${formattedVersionDate}`}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
